import { defineStore } from 'pinia'
import { UserInfo } from '../services/user'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null as UserInfo | null,
  }),

  actions: {
    // 设置用户信息
    setUserInfo(info: UserInfo) {
      this.userInfo = info
    },

    // 清除用户信息
    clearUserInfo() {
      this.userInfo = null
    },
  },

  getters: {
    // 获取用户信息
    getUserInfo(): UserInfo | null {
      return this.userInfo
    },
  },
})
